"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.create.title': 'Crea Nuova Professione',
};
